import React, { Component, Fragment } from "react";
import CollapseMenu from "../../../../config/atoms/CollapseMenu";
import MenuDetail from "../MenuDetail";
import { Link } from "react-router-dom";
import Loader from "../../../../config/molecules/loader/Loader";
import { dataKHS, calculateIPK } from "../../../../dummy-data/krs-khs";
import { dataMahasiswa } from "../../../../dummy-data/mahasiswa";


class Transkrip extends Component {
    state = {
        dataMhs: [],
        semester: [],
        listTranskrip: [],
        listBagiTranskrip: [],
        listD: [],
        listE: [],
        listMkBelumAmbil: [],
        isLoading: false,

        // params
        idVal: '',
        nimVal: ''
    };

    getDataMahasiswa = () => {
        const nim = this.state.nimVal;
        const mhs = dataMahasiswa.find(m => m.nim === nim);

        this.setState({
            dataMhs: {
                nim: nim,
                nama: mhs ? mhs.nama : 'Mahasiswa Demo',
                angkatan: mhs ? mhs.angkatan : '2020',
                jurusan: mhs ? mhs.prodi : 'Teknik Informatika',
                aliasJurusan: 'TI',
                fakultas: 'Fakultas Teknologi dan Desain',
                kurikulum: '2020',
                ttl: 'Malang, 01 Januari 2002',
                tglmasuk: '2020-09-01',
                tgllulus: '-',
                tgl_cetaktranskrip: new Date().toISOString().split('T')[0],
                dekan: 'Dr. Ahmad Susanto, M.Kom.',
                nidn_dekan: '0712098901',
                konsentrasi: '-',
                judul_ta: 'Pengembangan Sistem Informasi Akademik Berbasis Web',
                nina: '-',
                noijazah: '-'
            }
        });
    }

    getSemesterTranskrip = () => {
        const nim = this.state.nimVal;
        const khsData = dataKHS.filter(k => k.nim === nim);
        const semesters = [...new Set(khsData.map(k => k.semester_ke))].sort((a, b) => a - b);

        this.setState({
            semester: semesters.map(s => ({ semester: s }))
        });
    }

    handleTranskrip = (e) => {
        const nim = this.state.nimVal;
        const semesterKe = parseInt(e.target.value);

        this.setState({ isLoading: true });

        setTimeout(() => {
            // Get all KHS data up to selected semester
            const khsFiltered = dataKHS.filter(k => k.nim === nim && k.semester_ke <= semesterKe);

            // Map to transkrip format
            const transkripData = khsFiltered.map((k, idx) => ({
                no: idx + 1,
                matakuliah: k.nama_mk,
                sks: k.sks,
                grade: k.grade,
                nilai: k.bobot,
                sksn: (k.sks * k.bobot).toFixed(2)
            }));

            // Sort by nama mata kuliah
            transkripData.sort((a, b) => a.matakuliah.localeCompare(b.matakuliah));
            transkripData.forEach((item, idx) => item.no = idx + 1);

            const totalSKS = transkripData.reduce((sum, t) => sum + t.sks, 0);
            const totalSKSN = transkripData.reduce((sum, t) => sum + parseFloat(t.sksn), 0);
            const ipk = totalSKS > 0 ? (totalSKSN / totalSKS).toFixed(2) : 0;

            // Filter D and E grades
            const listD = transkripData.filter(t => t.grade === 'D').map(t => t.matakuliah);
            const listE = transkripData.filter(t => t.grade === 'E').map(t => t.matakuliah);

            this.setState({
                listTranskrip: transkripData,
                totalsks: totalSKS,
                totalSKsN: totalSKSN.toFixed(2),
                ipk: ipk,
                totalD: listD.length,
                listD: listD,
                totalE: listE.length,
                listE: listE,
                predikat: parseFloat(ipk) >= 3.5 ? 'Dengan Pujian' : parseFloat(ipk) >= 3.0 ? 'Sangat Memuaskan' : 'Memuaskan',
                listMkBelumAmbil: [],
                isLoading: false
            }, () => {
                this.splitInto2();
            });
        }, 300);
    }

    splitInto2 = () => {
        let json1 = [];
        let json2 = [];
        let data = this.state.listTranskrip;
        let hasilBagi = Math.round(parseInt(data.length) / 2);
        for (let i = 0; i < data.length; i++) {
            if (data[i].no <= hasilBagi) {
                json1.push(data[i]);
            } else {
                json2.push(data[i]);
            }
        }
        json1.map(function (json, key) {
            json["matched"] = json2[key];
        });
        this.setState({
            listBagiTranskrip: json1
        })
    };

    setParams = () => {
        const queryParams = new URLSearchParams(window.location.search);
        this.setState({
            idVal: queryParams.get('id'),
            nimVal: queryParams.get('nim')
        }, () => {
            this.getSemesterTranskrip()
            this.getDataMahasiswa()
        })
    }

    componentDidMount() {
        document.getElementById("Transkrip").classList.add("active");
        CollapseMenu("transkrip");
        this.setParams()
    };

    render() {
        return (
            <div>
                <Fragment>
                    <div className="col-md-12 mb-3">
                        <div className="row">
                            <div className="col-12 col-xl-8 mb-xl-0">
                                <p
                                    className="abu"
                                    style={{
                                        fontSize: "15px",
                                        fontWeight: "bold",
                                        color: "#999999",
                                        textTransform: "capitalize",
                                    }}
                                >
                                    Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Data
                                    Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp; Transkrip
                                </p>
                            </div>
                            <div className="col-12 col-xl-4 sm-md-none">
                                <div className="justify-content-end d-flex ">
                                    <div
                                        style={{ cursor: "pointer" }}
                                        title="expand/minimize"
                                        id="toogleMenu"
                                    >
                                        <i className="fa fa-expand abu" id="iconQ"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" id="smoothMain">
                        <div className="col-xl-3 order-xl-2 smoothTabs" id="menuKanan">
                            <MenuDetail id={this.state.idVal} nim={this.state.nimVal} />
                        </div>

                        <div className="col-xl-9" id="kontenKiri">
                            <div className="card card-custom">
                                <div className="card-body">
                                    <p
                                        className="card-title text-center"
                                        style={{
                                            fontSize: "25px",
                                            marginTop: "10px",
                                            marginBottom: "35px",
                                        }}
                                    >
                                        Transkrip Mahasiswa
                                    </p>

                                    <div className="table-responsive pl-2 pr-2">
                                        <table
                                            className="display expandable-table tableBord table-striped"
                                            style={{ width: "100%" }}
                                        >
                                            <thead></thead>
                                            <tbody>
                                                <tr>
                                                    <td>NIM</td>
                                                    <td> : </td>
                                                    <td>{this.state.dataMhs.nim}</td>

                                                    <td>Angkatan</td>
                                                    <td> : </td>
                                                    <td>{this.state.dataMhs.angkatan}</td>
                                                </tr>
                                                <tr>
                                                    <td>Nama</td>
                                                    <td> : </td>
                                                    <td>{this.state.dataMhs.nama}</td>

                                                    <td>Semester</td>
                                                    <td> : </td>
                                                    <td>
                                                        <select name="selectSemester" onChange={this.handleTranskrip} className="form-control custom-width" required>
                                                            <option value="" hidden>- Pilih Semester -</option>
                                                            {
                                                                this.state.semester.map((list, i) => {
                                                                    return (
                                                                        <option key={i} value={list.semester}>Semester {list.semester}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    {this.state.isLoading ? <Loader />
                                        :
                                        <>

                                            <div className="dropdown mt-4 mb-3 pr-2 pl-2">
                                                <button
                                                    className="btn btn-success dropdown-toggle"
                                                    type="button"
                                                    id="dropdownMenuButton"
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                >
                                                    <i className="fa fa-print"></i>&nbsp;&nbsp;Cetak PDF
                                                </button>
                                                <div
                                                    className="dropdown-menu"
                                                    aria-labelledby="dropdownMenuButton"
                                                >
                                                    <Link className="dropdown-item"
                                                        to={{
                                                            pathname: `/printtranskrip`,
                                                            state: {
                                                                list: this.state.listBagiTranskrip,
                                                                totalsks: this.state.totalsks,
                                                                totalSKsN: this.state.totalSKsN,
                                                                ipk: this.state.ipk,
                                                                totalD: this.state.totalD,
                                                                listD: this.state.listD,
                                                                totalE: this.state.totalE,
                                                                listE: this.state.listE,
                                                                predikat: this.state.predikat,

                                                                nama: this.state.dataMhs.nama,
                                                                nim: this.state.dataMhs.nim,
                                                                nina: this.state.dataMhs.nina,
                                                                konsentrasi: this.state.dataMhs.konsentrasi,
                                                                judulTA: this.state.dataMhs.judul_ta,

                                                                jurusan: this.state.dataMhs.jurusan,
                                                                aliasJurusan: this.state.dataMhs.aliasJurusan,
                                                                fakultas: this.state.dataMhs.fakultas,

                                                                ttl: this.state.dataMhs.ttl,
                                                                status: "Terakreditasi",
                                                                tglmsk: this.state.dataMhs.tglmasuk,
                                                                tgllulus: this.state.dataMhs.tgllulus,
                                                                tgl_cetaktranskrip: this.state.dataMhs.tgl_cetaktranskrip,

                                                                namadekan: this.state.dataMhs.dekan,
                                                                nidndekan: this.state.dataMhs.nidn_dekan,
                                                                noijazah: this.state.dataMhs.noijazah
                                                            }
                                                        }}
                                                    >
                                                        <i className="fa fa-print"></i>&nbsp;&nbsp;Transkrip
                                                    </Link>
                                                    <Link className="dropdown-item"
                                                        to={{
                                                            pathname: `/printtranskripsementara`,
                                                            state: {
                                                                list: this.state.listBagiTranskrip,
                                                                totalsks: this.state.totalsks,
                                                                totalSKsN: this.state.totalSKsN,
                                                                ipk: this.state.ipk,
                                                                totalD: this.state.totalD,
                                                                listD: this.state.listD,
                                                                totalE: this.state.totalE,
                                                                listE: this.state.listE,

                                                                nama: this.state.dataMhs.nama,
                                                                nim: this.state.dataMhs.nim,

                                                                jurusan: this.state.dataMhs.jurusan,
                                                                aliasJurusan: this.state.dataMhs.aliasJurusan,
                                                                fakultas: this.state.dataMhs.fakultas,
                                                                judulTA: this.state.dataMhs.judul_ta,
                                                                tgl_cetaktranskrip: this.state.dataMhs.tgl_cetaktranskrip,

                                                                ttl: this.state.dataMhs.ttl,

                                                                namadekan: this.state.dataMhs.dekan,
                                                                nidndekan: this.state.dataMhs.nidn_dekan,

                                                                angkatan: this.state.dataMhs.angkatan
                                                            }
                                                        }}
                                                    >
                                                        <i className="fa fa-print"></i>&nbsp;&nbsp;Transkrip
                                                        Sementara
                                                    </Link>
                                                    <Link className="dropdown-item"
                                                        to={{
                                                            pathname: `/printtranskripsementara-english`,
                                                            state: {
                                                                list: this.state.listBagiTranskrip,
                                                                totalsks: this.state.totalsks,
                                                                totalSKsN: this.state.totalSKsN,
                                                                ipk: this.state.ipk,
                                                                totalD: this.state.totalD,
                                                                listD: this.state.listD,
                                                                totalE: this.state.totalE,
                                                                listE: this.state.listE,

                                                                nama: this.state.dataMhs.nama,
                                                                nim: this.state.dataMhs.nim,

                                                                jurusan: this.state.dataMhs.jurusan,
                                                                aliasJurusan: this.state.dataMhs.aliasJurusan,
                                                                fakultas: this.state.dataMhs.fakultas,
                                                                judulTA: this.state.dataMhs.judul_ta,
                                                                tgl_cetaktranskrip: this.state.dataMhs.tgl_cetaktranskrip,

                                                                ttl: this.state.dataMhs.ttl,

                                                                namadekan: this.state.dataMhs.dekan,
                                                                nidndekan: this.state.dataMhs.nidn_dekan,

                                                                angkatan: this.state.dataMhs.angkatan
                                                            }
                                                        }}
                                                    >
                                                        <i className="fa fa-print"></i>&nbsp;&nbsp;Transkrip
                                                        Sementara (English)
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="table-responsive pl-2 pr-2 mt-4">
                                                <table
                                                    className="table-bordered table-transkrip"
                                                    style={{ width: "100%", fontSize: "13.3px" }}
                                                >
                                                    <thead>
                                                        <tr className="header-transkrip">
                                                            <th width="50px">
                                                                <center>No</center>
                                                            </th>
                                                            <th width="600px">
                                                                <center>Mata Kuliah</center>
                                                            </th>
                                                            <th width="70px">
                                                                <center>SKS</center>
                                                            </th>
                                                            <th width="70px">
                                                                <center>Nilai</center>
                                                            </th>
                                                            <th width="70px">
                                                                <center>Bobot</center>
                                                            </th>
                                                            <th width="70px">
                                                                <center>SKS x Bobot</center>
                                                            </th>

                                                            <th width="50px">
                                                                <center>No</center>
                                                            </th>
                                                            <th width="600px">
                                                                <center>Mata Kuliah</center>
                                                            </th>
                                                            <th width="70px">
                                                                <center>SKS</center>
                                                            </th>
                                                            <th width="70px">
                                                                <center>Nilai</center>
                                                            </th>
                                                            <th width="70px">
                                                                <center>Bobot</center>
                                                            </th>
                                                            <th width="70px">
                                                                <center>SKS x Bobot</center>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.listBagiTranskrip.map((list, i) => {
                                                            return (
                                                                <tr key={i}>
                                                                    <td className="no-transkrip">
                                                                        <center>{list.no}</center>
                                                                    </td>
                                                                    <td>{list.matakuliah}</td>
                                                                    <td>
                                                                        <center>{list.sks}</center>
                                                                    </td>
                                                                    <td>
                                                                        <center>{list.grade}</center>
                                                                    </td>
                                                                    <td>
                                                                        <center>{list.nilai}</center>
                                                                    </td>
                                                                    <td>
                                                                        <center>{list.sksn}</center>
                                                                    </td>
                                                                    {
                                                                        list.matched == undefined ?
                                                                            <>
                                                                                <td className="no-transkrip">
                                                                                    <center>&nbsp;</center>
                                                                                </td>
                                                                                <td></td>
                                                                                <td>
                                                                                    <center></center>
                                                                                </td>
                                                                                <td>
                                                                                    <center></center>
                                                                                </td>
                                                                                <td>
                                                                                    <center></center>
                                                                                </td>
                                                                                <td>
                                                                                    <center></center>
                                                                                </td>
                                                                            </>
                                                                            :
                                                                            <>
                                                                                <td className="no-transkrip">
                                                                                    <center>{list.matched.no}</center>
                                                                                </td>
                                                                                <td>{list.matched.matakuliah}</td>
                                                                                <td>
                                                                                    <center>{list.matched.sks}</center>
                                                                                </td>
                                                                                <td>
                                                                                    <center>{list.matched.grade}</center>
                                                                                </td>
                                                                                <td>
                                                                                    <center>{list.matched.nilai}</center>
                                                                                </td>
                                                                                <td>
                                                                                    <center>{list.matched.sksn}</center>
                                                                                </td>
                                                                            </>
                                                                    }
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                                <table className="table-footer mt-4 mb-4">
                                                    <tbody>
                                                        <tr>
                                                            <td>Total NA x SKS </td>
                                                            <td width='50px'></td>
                                                            <td>:</td>
                                                            <td width='10px'></td>
                                                            <td>{this.state.totalSKsN}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Jumlah SKS </td>
                                                            <td width='50px'></td>
                                                            <td>:</td>
                                                            <td width='10px'></td>
                                                            <td>{this.state.totalsks}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>IP Kumulatif </td>
                                                            <td width='50px'></td>
                                                            <td>:</td>
                                                            <td width='10px'></td>
                                                            <td>{this.state.ipk}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <br />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Total Nilai D </td>
                                                            <td width='50px'></td>
                                                            <td>:</td>
                                                            <td width='10px'></td>
                                                            <td>{this.state.totalD} Mata Kuliah</td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan={4}></td>
                                                            <td>
                                                                {
                                                                    this.state.listD.map((list, i) => {
                                                                        return (
                                                                            <p>{i + 1}. {list}</p>
                                                                        )
                                                                    })
                                                                }
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Total Nilai E </td>
                                                            <td width='50px'></td>
                                                            <td>:</td>
                                                            <td width='10px'></td>
                                                            <td>{this.state.totalE} Mata Kuliah</td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan={4}></td>
                                                            <td>
                                                                {
                                                                    this.state.listE.map((list, i) => {
                                                                        return (
                                                                            <p>{i + 1}. {list}</p>
                                                                        )
                                                                    })
                                                                }
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="table-responsive">
                                                <h5>Mata Kuliah Yang Belum Diambil :</h5>
                                                <table width="100%" align="center" className="display expandable-table table-bordered table-radius">
                                                    <thead>
                                                        <tr align="center">
                                                            <th style={{ borderRadius: '0px' }}>No</th>
                                                            <th>Mata Kuliah</th>
                                                            <th>SKS Teori</th>
                                                            <th>SKS Praktek</th>
                                                            <th>Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.listMkBelumAmbil.map((list, i) => {
                                                                return (
                                                                    <tr key={i}>
                                                                        <td>{i + 1}</td>
                                                                        <td>{list.matakuliah}</td>
                                                                        <td>{list.sksteori}</td>
                                                                        <td>{list.skspraktek}</td>
                                                                        <td>{list.status}</td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            </div>
        );
    }
}

export default Transkrip;
